module.exports = __webpack_public_path__ + "img/31.42b05807.png";